module.exports = __webpack_public_path__ + "img/tagitiva.f14b53bd.png";